<mat-form-field class="mat-block" [ngClass]="{'l-updated-field': isOverriden}">
  <mat-select
    id="ddLongTime"
    [formControl]="ctrlLongTime"
    [placeholder]="placeholder"
    [required]="ctrlLongTime.hasError('required')"
  >
    <mat-option *ngFor="let longTime of longTimeList" [value]="longTime">
      {{longTime.format}}
    </mat-option>
  </mat-select>
  <mat-error
    id="errLongTime"
    class="error-message"
    *ngIf="ctrlLongTime.dirty || ctrlLongTime.touched"
  >
    {{ "organization.create.section_3.long_time_required" | translate }}
  </mat-error>
</mat-form-field>
